angular.module('bbl.module.call-records.routing', [])
  .config(['$routeProvider', callRecordsRoutingSetup]);

function callRecordsRoutingSetup($routeProvider) {
  var resolveAuth = {
    profile: ["Auth", function(Auth) {
      return Auth.getProfile().then(function(response) {
        return response.data.profile;
      });
    }], permissions: ["Auth", "$q", function(Auth, $q) {
      return Auth.getPermission().then(function(response) {
        if(!(response.data.permission_level == 3 || response.data.permission_level == 2)) {
          return $q.reject({ authenticated: false });
        }

        return response.data.permission_level;
      });
    }]
  };
  
  var callRecordsRoute = {
    templateUrl: 'records-template.html',
    controller: 'CallRecordsController',
    resolve: resolveAuth
  };

  $routeProvider.when('/call-records', callRecordsRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/call-records/call-records.routing.js
 ** module id = 361
 ** module chunks = 0
 **/